<div class="modal-content">

  <!-- Cabeçalho do Modal com título e botão de fechar -->
  <div class="modal-header">
    <h5 class="modal-title">
      Atualizar: {{item?.item}}
    </h5>
    <button type="button" class="btn-close" aria-label="Fechar" (click)="activeModal.dismiss()"></button>
  </div>

  <div class="modal-body p-4">
    <form [formGroup]="itemForm" (ngSubmit)="atualizarItem()">
      <input hidden formControlName="id">
      <input hidden formControlName="item">
      <input hidden formControlName="tipoDeCalculo">
      <div class="row">

        <div *ngIf="tipoDeCalculo === 1 || tipoDeCalculo === 3" class="col-md-4">
          <div class="mb-3 position-relative">
            <label class="form-label">Quantidade <span style="color: red;">*</span></label>
            <input formControlName="quantidade" oninput="this.value = Math.abs(this.value)" min="0" type="number"
              class="form-control form-control-sm" placeholder="0" min="1">
          </div>
        </div>

        <div *ngIf="tipoDeCalculo === 2" class="col-md-4">
          <div class="mb-3 position-relative">
            <label class="form-label">Dias <span style="color: red;">*</span></label>
            <input formControlName="quantidadeDeDia" min="0" oninput="this.value = Math.abs(this.value)" type="number"
              class="form-control form-control-sm" placeholder="0" min="1">
          </div>
        </div>

        <div *ngIf="tipoDeCalculo === 2" class="col-md-4">
          <div class="mb-3 position-relative">
            <label class="form-label">Pessoas <span style="color: red;">*</span></label>
            <input formControlName="quantidadeDePessoa" min="0" oninput="this.value = Math.abs(this.value)"
              type="number" class="form-control form-control-sm" placeholder="0" min="1">
          </div>
        </div>

        <!-- <div class="col-md-4">
          <div class="mb-3 position-relative">
            <label class="form-label">V. Unit</label>
            <input formControlName="valorUnitario" type="text" placeholder="0" class="form-control form-control-sm">
          </div>
        </div> -->
        
        <div *ngIf="item?.tipoItemOrcamento == 3" class="col-md-1">

          <label class="form-label">Sobrepor</label>
          <div class="d-flex">
            <div class="form-check">
              <input formControlName="sobrepor" class="form-check-input" type="radio" id="formRadios2" value="1">
              <label class="form-check-label" for="formRadios2">
                S
              </label>
            </div>
            <div class="form-check ms-3">
              <input formControlName="sobrepor" class="form-check-input" type="radio" id="formRadios1" value="0" checked>
              <label class="form-check-label" for="formRadios1">
                N
              </label>
            </div>
          </div>

        </div>

      </div>

      <div class="row">
        <div class="col-3">
          <button type="submit" class="btn btn-success btn-sm w-md">Atualizar</button>
        </div>
      </div>
    </form>
  </div>
</div>